import * as MUI from "@mui/material";

/** Stacked label/value row: label caption above value. */
export default function DetailRow({ label, value }) {
  if (!value) return null;
  return (
    <MUI.Stack spacing={0.5}>
      <MUI.Typography variant="caption" color="text.secondary">
        {label}
      </MUI.Typography>
      <MUI.Typography variant="body2" sx={{ fontWeight: 500, whiteSpace: "pre-wrap" }}>
        {value}
      </MUI.Typography>
    </MUI.Stack>
  );
}
